import approval from './approval.middleware'
import auth from './auth.middleware'
import common from './common.middleware'
import hr from './hr.middleware'

export default [...approval, ...auth, ...common, ...hr]
